/**
 * Serializable snapshot of the direct-auth session. The actual Signer lives in
 * the in-memory singleton (src/web/src/auth/session.ts); this slice only tracks
 * whether the session is unlocked and the derived AID (for display / guards).
 * See this.i wqz7k3mnbp.
 */

import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

export interface AuthSessionState {
  unlocked: boolean;
  /** Non-transferable AID (qb64) of the unlocked identity, or null when locked. */
  aid: string | null;
}

const initialState: AuthSessionState = {
  unlocked: false,
  aid: null,
};

const authSessionSlice = createSlice({
  name: 'authSession',
  initialState,
  reducers: {
    unlock(state, action: PayloadAction<{aid: string}>) {
      state.unlocked = true;
      state.aid = action.payload.aid;
    },
    lock(state) {
      state.unlocked = false;
      state.aid = null;
    },
  },
});

export const {unlock, lock} = authSessionSlice.actions;
export default authSessionSlice.reducer;
